import React from "react";
import { Input } from "antd";
import { EyeFilled, EyeInvisibleFilled } from "@ant-design/icons";

const CustomInputPassword = ({ placeholder, onChange, value, id }) => (
	<Input.Password
		size={"large"}
		id={id}
		autoComplete={"off"}
		value={value}
		placeholder={placeholder}
		onChange={e => onChange(e.target.value)}
		iconRender={visible => (visible ? <EyeFilled /> : <EyeInvisibleFilled />)}
	/>
);

export default CustomInputPassword;
